import { useQuery, useManualQuery } from 'graphql-hooks';

const query = `
query GetMlItemByUpc($upc: String!) {
    getMlItemByUpc(upc: $upc) {
        id
        title
        category_id
        status
        catalog_listing
        descriptions
        pictures {
            url
            secure_url
            size
            max_size
            quality
        }
        tags
        price
        currency_id
    }
}
`

export const useGetMlItemByUpc = (upc: string) => {
    const { loading, error, data } = useQuery(query, {
        variables: {
            upc
        }
    });
    return {
        loading,
        error,
        data
    }
}

export const useGetMlItemByUpcManual = () => {
    const [getMlItemByUpc, { loading, data, error }] = useManualQuery(query);
    return {
        loading,
        error,
        data,
        getMlItemByUpc
    }
}